<template>
  <section class="mission module">
    <div class="container large">
      <div class="mission-head">
        <div class="section-intro">
          <div
            class="tagline eyebrow"
            v-html="data.mission_tagline"></div>
          <div
            class="headline h2"
            v-html="data.mission_headline"></div>
          <a
            v-if="data.mission_link"
            :href="data.mission_link.url"
            :target="data.mission_link.target"
            class="btn trans-white"
            >{{ data.mission_link.title }}</a
          >
        </div>
      </div>
      <div class="mission-items">
        <div class="mission-item empty"></div>
        <div
          v-for="(item, index) in data.mission_items"
          :key="index"
          class="mission-item border-radius">
          <div
            class="title h5"
            :class="item.mission_item_color.value"
            v-html="item.mission_item_title"></div>
          <div
            class="text"
            v-html="item.mission_item_text"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
   {
    "NAME": "MissionComponent",
    "CLASSNAME": "mission",
    "URL": "http://eikon.local/"
   }
  #ENDMETA */
defineProps(['data'])
</script>

<style lang="scss">
.mission {
  color: $white;
  background-color: $black;

  &-head {
    .section-intro {
      .headline {
        @include mobile {
          margin-bottom: 26px;
        }
      }
    }
  }
  .mission-items {
    @apply flex flex-col gap-[10px] mt-[62px]
    lg:flex-row lg:flex-wrap lg:mt-[160px];

    .mission-item {
      @apply relative flex flex-col justify-between min-h-[150px] 
      p-[25px]
      [background:rgba(100,100,100,0.2)] backdrop-blur-[14.6px]
      lg:w-[24%] lg:min-h-[240px];

      &:hover {
        .title:after {
          transform: scale(1.2);
        }
      }

      &.empty {
        @apply hidden
        lg:flex;
        background: none;
      }

      &:nth-child(4n + 4) {
        margin-right: 0;
      }

      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &.orange:after {
          box-shadow:
            0px 0px 11.6px $orange,
            0px 0px 62.8px $orange;
          background-color: $orange;
        }

        &.indigo:after {
          box-shadow:
            0px 0px 11.6px $indigo,
            0px 0px 62.8px $indigo;
          background-color: $indigo;
        }

        &.yellow:after {
          box-shadow:
            0px 0px 11.6px $yellow,
            0px 0px 62.8px $yellow;
          background-color: $yellow;
        }

        &.blue:after {
          box-shadow:
            0px 0px 11.6px $blue,
            0px 0px 62.8px $blue;
          background-color: $blue;
        }

        &.pink:after {
          box-shadow:
            0px 0px 11.6px $cerise,
            0px 0px 62.8px $cerise;
          background-color: $cerise;
        }

        &.magenta:after {
          box-shadow:
            0px 0px 11.6px $magenta,
            0px 0px 62.8px $magenta;
          background-color: $magenta;
        }

        &:after {
          content: '';
          display: block;
          width: 21px;
          height: 21px;
          border-radius: 50%;
          background-color: attr(data-color);
          transform: scale(1);
          @include transition;
        }
      }
    }
  }
}
</style>
